import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransportCapacityRoutingModule } from './transport-capacity-routing.module';
import { TransportCapacityComponent } from './transport-capacity.component';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [TransportCapacityComponent],
  imports: [
    CommonModule,
    SharedModule,
    TransportCapacityRoutingModule
  ]
})
export class TransportCapacityModule { }
